<div class="gallery">
  <div class="albums">
    <div class="album" *ngFor="let img of allBuildingMonth;" (click)="openAlbum(img.allBuildingImagePerMonth)">
      <ng-container>
        <!-- <div class="btn btn-apply auto">Загрузить фото</div> -->
        <div *ngFor="let it of img?.allBuildingImagePerMonth; let i = index">
          <div class="image" *ngIf="i<4">
            <ng-container>
              <img [src]="it.src" alt="">
              <div *ngIf="it.fileTypeID === 2" class="play-icon"> <img src="./assets/svg-icons/play.svg" alt=""> </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <!-- To do check error -->
      <!-- <div class="loading" *ngIf="lastFourLoader"></div> -->
      <div class="album_title" [ngStyle]="{'color':'black'}">{{img?.monthName}}</div>
    </div>
  </div>
  <div class="btns">
    <div class="btn btn-apply">Загрузить
      <input type="file"
      accept="video/quicktime,video/avi,video/mp4,video/mov,video/3gp,video/mkv,video/wmv,video/mpeg,video/mpg,video/vob,video/flv,
        image/png,image/jpg,image/jpeg,image/jfif,image/gif,image/tiff,image/psd,image/bmp,image/raw,image/svg,image/pct,image/tif"
      id="file" multiple (change)="handleFileInputForBuildings($event.target.files)">
    </div>
  </div>
</div>
<app-modal-window *ngIf="openMonthModal" [title]="''" [visible]="openMonthModal" (close)="openMonthModal = $event"
  [scrollbar]="false">
  <div class="album-block">
    <div class="album" *ngIf="!loader">
      <div class="image" *ngFor="let img of buildingImagesPerMonth; let i = index" (click)="openImage(img)">
        <div class="loading" *ngIf="loader"></div>
        <img [src]="img.src" alt="" [ngClass]="checkBox ? 'opacity':''">
        <div class="caption">{{ img.updatedOn }}</div>
        <div *ngIf="img.fileTypeID === 2" class="play-icon"><img src="./assets/svg-icons/play.svg"></div>
        <div class="checkbox" *ngIf="checkBox" (click)="selectImage(img);$event.stopPropagation()" [ngClass]="img.selected == true ? 'active': ''"></div>
      </div>
    </div>

    <div class="loading big" *ngIf="loader"></div>
    <div class="btns">
      <div class="btn" (click)="selectedImages()" [ngClass]="checkBox?'btn-cancel':'btn-apply'">{{checkBox?'Отмена':'Выбрать'}}</div>
      <div class="btn" (click)="deleteBtn?deleteImages():''" [ngClass]="deleteBtn?'btn-apply':'btn-cancel none'">Удалить</div>
      <div class="btn btn-apply">Загрузить
        <input type="file" id="file" multiple (change)="handleFileInputForBuildings($event.target.files)">
      </div>
      <div class="btn btn-apply" *ngIf="getCount()" (click)="updateMainPhoto()"> Сделать основным фото </div>
    </div>
  </div>


  <ng-container *ngIf="openImg">
    <app-modal-window *ngIf="openImg" [title]="''" [visible]="openImg" (close)="openImg = $event" [scrollbar]="false"
      [type]="'preview'" [height]="420" [width]="1300">
      <ng-container *ngIf="allBuildingImage.length > 1">
        <div class="btn-slide to-left" (click)="clickedSlider('left', selectedImg)">❮</div>
        <div class="btn-slide to-right" (click)="clickedSlider('right', selectedImg)">❯</div>
      </ng-container>
      <div class="img-block">
        <img *ngIf="selectedImg?.fileTypeID === 1" [src]="selectedImg?.srcFalse">
        <video *ngIf="selectedImg?.fileTypeID === 2" width="100%" controls="controls" autoplay>
          <source [src]="selectedImg?.srcFalse">
        </video>
      </div>
      <div class="comment">
        <div class="comments-old" *ngIf="commentsPhoto?.length !== 0">
          <div class="comment-old" *ngFor="let comment of commentsPhoto">
            <div class="added-com">{{comment.comment}}</div>
            <div class="added-com">{{comment.userName}}</div>
            <div class="added-com">{{comment.updatedOn}}</div>
          </div>
        </div>
        <div *ngIf="commentsPhoto?.length === 0">
          Коментариев нет
        </div>
        <div>
          <h4>Оставить коментарий</h4>
          <textarea name="" id="" cols="60" rows="10" [(ngModel)]="comment.Comment"></textarea>
        </div>
        <div>
          <button class="btn" (click)="sendComment(selectedImg.fileId)">Отправить</button>
        </div>
      </div>
    </app-modal-window>
  </ng-container>
</app-modal-window>
